import { mutatorAction } from 'satcheljs';
import InlineImageViewState from '../schema/InlineImageViewState';
import ImageStatus from '../schema/ImageStatus';

const setImageState = mutatorAction(
    'SetImageState',
    (
        viewState: InlineImageViewState,
        temporaryId: string,
        status: ImageStatus,
        placeholder?: HTMLElement
    ) => {
        viewState.imageStatusMap[temporaryId] = {
            status,
            placeholder,
        };
    }
);

export default setImageState;
